import { Params } from '@angular/router';

export const AR_ROUTE = {
  name: 'ar',
  route(): string[] {
    return [this.name];
  },

  DEFAULT: '',

  VIEW: {
    name: 'view',
    route(): string[] {
      return [...AR_ROUTE.route(), this.name];
    },
    queryParams(url: string): Params {
      return {
        url: encodeURIComponent(url),
      };
    }
  },

  SUPPORT_ERROR: {
    name: 'unsupported',
    route(): string[] {
      return [...AR_ROUTE.route(), this.name];
    }
  }
};
